import axiosInstance from "../axiosInstance"
import type {
  UploadedFileDto,
  DeleteUploadedFileResponseDto,
} from "../types/uploadedFile.types"

/**
 * Uploaded File API Client
 * Direct API calls using axios instance
 */
export const uploadedFileClient = {
  /**
   * Upload a file to S3
   * @param file - File object to upload
   * @returns Promise with uploaded file metadata
   */
  uploadFile: (file: File): Promise<UploadedFileDto> => {
    const formData = new FormData()
    formData.append("file", file)
    return axiosInstance.post("/uploaded-files", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
  },

  /**
   * Get uploaded file metadata by ID
   * @param id - File ID (UUID)
   * @returns Promise with file metadata
   */
  getUploadedFile: (id: string): Promise<UploadedFileDto> => {
    return axiosInstance.get(`/uploaded-files/${id}`)
  },

  /**
   * Delete uploaded file (S3 and metadata)
   * @param id - File ID (UUID)
   * @returns Promise with delete confirmation
   */
  deleteUploadedFile: (id: string): Promise<DeleteUploadedFileResponseDto> => {
    return axiosInstance.delete(`/uploaded-files/${id}`)
  },
}

